import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import _ from 'lodash';
import { useCounterOfferCountdown } from './utils';
import { InfoPill, Text } from '../../../elementals';
import { ColorNames } from '../../../../constants';
import * as utils from '../../../../utils';
const CounterOfferCountdown = ({ bid, className, }) => {
    const expirationDate = _.get(bid?.terms, 'expiration_date');
    const secondsRemaining = useCounterOfferCountdown(bid);
    if (!expirationDate || secondsRemaining <= 0)
        return null;
    return (_jsx("div", { className: className, children: _jsx(InfoPill, { size: 'small', backgroundColor: ColorNames.CautionLight, foregroundColor: ColorNames.Caution, includeBorder: true, iconName: 'clock', extraPadding: 'small', label: _jsx(_Fragment, { children: _jsxs(Text.Body, { as: 'div', size: 'small', color: ColorNames.Caution, children: ["This Counteroffer expires in", ' ', _jsx("strong", { children: utils.countdown.formatCountdownTimeWithoutText(secondsRemaining) })] }) }) }) }));
};
export default CounterOfferCountdown;
//# sourceMappingURL=index.js.map